import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TermsOfAgreementsAnswer} from "../../models/terms-of-agreements-answers.model";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {TermsOfAgreementService} from "../../providers/terms-of-agreement.service";
import {TermsOfAgreementCustomParam} from "../../models/terms-of-agreement.model";
import {retry} from "rxjs/operators";

@Component({
  selector: 'app-term-placeholder',
  templateUrl: './term-placeholder.component.html',
  styleUrls: ['./term-placeholder.component.scss'],
})
export class TermPlaceholderComponent implements OnInit {
  termsOfAgreement: string;
  @Input()
  termOfAgreementAnswers: TermsOfAgreementsAnswer;

  @Input()
  termsOfAgreementCustomParams: Map<string, TermsOfAgreementCustomParam[]>;

  @Output()
  emitGeneratedToa: EventEmitter<string> = new EventEmitter<string>();

  showTerms: boolean = false;
  isAccepted: boolean = false;
  isBusy: boolean;

  constructor(public commonUtils : CommonUtils, private appStateService: AppStateService, private termsOfAgreementService: TermsOfAgreementService) {
  }

  ngOnInit() {
    this.appStateService.isBusySubject.subscribe(e=>{
      this.isBusy=e;
    });

    this.appStateService.updateIsBusySubject(true);
    // this.termsOfAgreementService.getTemplate().subscribe(template=>{
    //   this.termsOfAgreement = template;
    //   this.replace();
    //   this.appStateService.updateIsBusySubject(false);
    //  })
  }

  replace() {
    this.termsOfAgreement = this.termsOfAgreement.replace('#CLINIC_NAME#', this.termOfAgreementAnswers.clinicName);
    this.termsOfAgreement = this.termsOfAgreement.replace('#CLINIC_NAME#', this.termOfAgreementAnswers.clinicName);
    this.termsOfAgreement = this.termsOfAgreement.replace('#CLINIC_ADDRESS#', this.termOfAgreementAnswers.clinicAddress);
    this.termsOfAgreement = this.termsOfAgreement.replace('#PPREP_LOCK_DATE#', this.termOfAgreementAnswers.prepaidLockDate);
    this.termsOfAgreement = this.termsOfAgreement.replace('#MAX_REX_CANCEL#', this.termOfAgreementAnswers.maxReservationCancellation);
    this.termsOfAgreement = this.termsOfAgreement.replace('#CMPL_EMAIL#', this.termOfAgreementAnswers.complaintEmailAddress);
    this.termsOfAgreement = this.termsOfAgreement.replace('#CMPL_CONS_DAYS#', this.termOfAgreementAnswers.complaintConsiderationDays + '');

    if (this.termsOfAgreementCustomParams && this.termsOfAgreementCustomParams instanceof Map) {
      let keysReplaced = [];

      for (let key of this.termsOfAgreementCustomParams.keys()) {
        const items = this.termsOfAgreementCustomParams.get(key);
        let pContent = '';
        let pContentText = '';

        if (items) {
          pContent += '';

          this.termsOfAgreementCustomParams.get(key).forEach(tosCP => {
            pContent += `<li>${tosCP.text}</li>`
            pContentText += `${tosCP.text}`;
          })
        }

        this.termsOfAgreement = this.termsOfAgreement.replace(`#CUSTOM_P${key}#`, pContent);
        this.termsOfAgreement = this.termsOfAgreement.replace(`#CUSTOM_TEXT_P${key}#`, pContentText);

        keysReplaced.push(key);
      }

      for (let i = 1; i < 10; i++) {
        if (!keysReplaced.includes(i)) {
          this.termsOfAgreement = this.termsOfAgreement.replace(`#CUSTOM_P${i}#`, '');
          this.termsOfAgreement = this.termsOfAgreement.replace(`#CUSTOM_TEXT_P${i}#`, '');
        }
      }
    } else {
      this.termsOfAgreement = this.termsOfAgreement.replace('#CUSTOM_P1#', '');
      this.termsOfAgreement = this.termsOfAgreement.replace('#CUSTOM_P2#', '');
      this.termsOfAgreement = this.termsOfAgreement.replace('#CUSTOM_P3#', '');
      this.termsOfAgreement = this.termsOfAgreement.replace('#CUSTOM_P4#', '');
      this.termsOfAgreement = this.termsOfAgreement.replace('#CUSTOM_P5#', '');
      this.termsOfAgreement = this.termsOfAgreement.replace('#CUSTOM_P6#', '');
      this.termsOfAgreement = this.termsOfAgreement.replace('#CUSTOM_P7#', '');
      this.termsOfAgreement = this.termsOfAgreement.replace('#CUSTOM_TEXT_P7#', '');
      this.termsOfAgreement = this.termsOfAgreement.replace('#CUSTOM_P8#', '');
      this.termsOfAgreement = this.termsOfAgreement.replace('#CUSTOM_P9#', '');
    }

    this.showTerms = true;
  }

  onToggleAccept() {
    this.isAccepted = !this.isAccepted;
    if (this.isAccepted) {
      this.emitGeneratedToa.emit(this.termsOfAgreement);
    } else {
      this.emitGeneratedToa.emit(null);
    }
  }
}
